import { render, staticRenderFns } from "./monitoring-service-order-detail-modal.vue?vue&type=template&id=c67aa924&scoped=true"
import script from "./monitoring-service-order-detail-modal.vue?vue&type=script&lang=js"
export * from "./monitoring-service-order-detail-modal.vue?vue&type=script&lang=js"
import style0 from "./monitoring-service-order-detail-modal.vue?vue&type=style&index=0&id=c67aa924&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c67aa924",
  null
  
)

export default component.exports